import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Members Statistics"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Over 500 members")
], -1)
const _hoisted_3 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add a user"
}
const _hoisted_4 = {
  href: "#",
  class: "btn btn-sm btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_invite_friends"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New Member ")
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "\n            table table-row-dashed table-row-gray-300\n            align-middle\n            gs-0\n            gy-4\n          " }
const _hoisted_10 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "w-25px" }, [
      /*#__PURE__*/_createVNode("div", { class: "\n                    form-check form-check-sm form-check-custom form-check-solid\n                  " }, [
        /*#__PURE__*/_createVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          value: "1"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Authors"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-140px" }, "Company"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-120px" }, "Progress"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px text-end" }, "Actions")
  ])
], -1)
const _hoisted_11 = { class: "\n                      form-check\n                      form-check-sm\n                      form-check-custom\n                      form-check-solid\n                    " }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "symbol symbol-45px me-5" }
const _hoisted_14 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_15 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-6"
}
const _hoisted_16 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_17 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block fs-6"
}
const _hoisted_18 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_21 = { class: "d-flex flex-stack mb-2" }
const _hoisted_22 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_23 = { class: "progress h-6px w-100" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                      me-1\n                    "
}
const _hoisted_26 = { class: "svg-icon svg-icon-3" }
const _hoisted_27 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                      me-1\n                    "
}
const _hoisted_28 = { class: "svg-icon svg-icon-3" }
const _hoisted_29 = {
  href: "#",
  class: "\n                      btn btn-icon btn-bg-light btn-active-color-primary btn-sm\n                    "
}
const _hoisted_30 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", {
    class: ["card", _ctx.widgetClasses]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("table", _hoisted_9, [
          _hoisted_10,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("input", {
                      class: "form-check-input widget-9-check",
                      type: "checkbox",
                      value: index
                    }, null, 8, ["value"])
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("img", {
                        src: item.image,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("a", _hoisted_15, _toDisplayString(item.name), 1),
                      _createVNode("span", _hoisted_16, _toDisplayString(item.skills), 1)
                    ])
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_17, _toDisplayString(item.companyName), 1),
                  _createVNode("span", _hoisted_18, _toDisplayString(item.companySkills), 1)
                ]),
                _createVNode("td", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("span", _hoisted_22, _toDisplayString(item.value) + "% ", 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", {
                        class: ["progress-bar", `bg-${item.color}`],
                        role: "progressbar",
                        style: { width: item.value + '%' },
                        "aria-valuenow": item.value,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 14, ["aria-valuenow"])
                    ])
                  ])
                ]),
                _createVNode("td", _hoisted_24, [
                  _createVNode("a", _hoisted_25, [
                    _createVNode("span", _hoisted_26, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen019.svg" })
                    ])
                  ]),
                  _createVNode("a", _hoisted_27, [
                    _createVNode("span", _hoisted_28, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                    ])
                  ]),
                  _createVNode("a", _hoisted_29, [
                    _createVNode("span", _hoisted_30, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}